import { OUTLOOK_BEAUTIFIED_PREFIX, OWA_ID_PREFIX } from 'owa-attachment-link-common';
import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';
import { getGuid } from 'owa-guid';
import { AnchorElementsSource } from 'owa-link-data';
import { isBeautifulLink } from './isBeautifulLink';

const classNames = require('classnames');
export default function trySetIdAndClassName(
    anchorElement: HTMLAnchorElement,
    source: AnchorElementsSource,
    shouldChangeLinkId: boolean
) {
    if (!anchorElement.id || anchorElement.id.length === 0 || shouldChangeLinkId) {
        if (isBeautifulLink(anchorElement, source === AnchorElementsSource.PasteHtml)) {
            anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + getGuid();
        } else {
            anchorElement.id = OWA_ID_PREFIX + getGuid();
        }
    }
    if (anchorElement.className.indexOf(OWA_AUTO_LINKS_CLASSNAME) !== -1) {
        return;
    }

    anchorElement.className = classNames(anchorElement.className, OWA_AUTO_LINKS_CLASSNAME);
}
